import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ClientFormPageStepsModule } from '../client-form-page-steps/client-form-page-steps.module';
import { TokenInterceptor } from '../interceptor/token.interceptor';
import { ClientEvideFormService } from '../services/client-evide-form.service';
import { ClientFormComponent } from './client-form.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({

  declarations: [ClientFormComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ClientFormPageStepsModule,
    SharedModule
  ],
  exports: [ClientFormComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    ClientEvideFormService,
  ]
})
export class ClientFormModule { }
